const STATE_VERSION = 2;
const STORAGE_KEY = "vuex";

function resetOutdatedPersistedState(storage) {
  const saved = storage.getItem(STORAGE_KEY);
  if (saved == null) return false;
  try {
    if (JSON.parse(saved)?.stateVersion === STATE_VERSION) return false;
  } catch (_) {
    // Invalid or older state cannot safely contain reusable public IDs or credentials.
  }
  storage.removeItem(STORAGE_KEY);
  return true;
}

module.exports = { STATE_VERSION, resetOutdatedPersistedState };
